import { FC } from 'react';
import { cvaSpinner, cvaSpinnerContainer } from './LoadingSpinnerStyles';
import clsx from 'clsx';

interface Props {
  className?: string;
  size?: 'default' | 'button' | 'small';
  text?: string;
}

export const LoadingSpinner: FC<Props> = ({ className, size, text }) => {
  return (
    <div role="status" className={clsx(cvaSpinnerContainer(), className)}>
      {text && <p className="mb-2">{text}</p>}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={cvaSpinner({ size })}
        viewBox="0 0 24 24">
        <path
          d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
          data-original="#FFFFFF"
        />
      </svg>
    </div>
  );
};
